import {Box, Chip, Typography} from "@mui/material";
import React from "react";

export const ServiceInterfaces = ({endpoint}) => {
    const response = [];
    if (!endpoint?.interfaces) return null;

    for (let int of endpoint?.interfaces) {
        // response.push(<Chip label={<Typography variant="caption">{int}</Typography>} size="small" style={{cursor: "pointer"}} variant="outlined" />)
        response.push(<Typography variant="body2">{int}</Typography>)
    }

    return response
}